import React, { useState, useEffect } from 'react';
import Section from "../components/Section";
import Footer from "../components/Footer";
import BlogBox from '../components/BlogBox';

import '../styles/Blog.css';

function Blog(){
    const [posts, setPosts] = useState([]);

    useEffect(() => {
        fetch('https://ryonasset.com/api/posts', {
            headers: {
                'Content-Type': 'application/json'
            }
        })
        .then(response => {
            if (response.ok) {
                return response.json();
            }
            throw new Error('Network response was not ok.');
        })
        .then(data => {
            setPosts(data);
        })
        .catch(error => {
            console.error('There has been a problem with your fetch operation:', error);
        });
    }, []);

    return(
        <div className='main-wrapper'>
        <main style={{paddingTop:'100px'}}>
            <Section title="Blog">
            <div className="sect-side-space">
            <ul className="blog-list-container">
                {posts.map(post => (
                    <BlogBox
                        key={post.id}
                        id={post.id}
                        title={post.title}
                        desc={post.desc}
                        author={post.author}
                        isExternalLink={post.is_external_link}
                        link={post.link}
                        preview={post.preview}
                        date={post.date}
                    />
                ))}
            </ul>
            </div>
            </Section>
        </main>
        <Footer />
        </div>
    );
}

export default Blog;